import React from 'react';
import { Clock, CheckCircle } from 'lucide-react';
import { businessHours } from '../utils/mock';

export const BusinessHours = () => {
  const currentDay = new Date().getDay();
  const isOpen = currentDay >= 1 && currentDay <= 6; // Monday = 1, Saturday = 6
  const currentHour = new Date().getHours();
  const isDuringBusinessHours = currentHour >= 10 && currentHour < 19; // 10 AM to 7 PM

  const isCurrentlyOpen = isOpen && isDuringBusinessHours;

  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
      <div className="flex items-start gap-4">
        <div className={`p-3 rounded-full ${
          isCurrentlyOpen 
            ? 'bg-green-100' 
            : 'bg-gray-100'
        }`}>
          <Clock className={`h-6 w-6 ${
            isCurrentlyOpen 
              ? 'text-green-600' 
              : 'text-gray-600'
          }`} />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-xl font-bold text-gray-900">Business Hours</h3>
            <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold ${
              isCurrentlyOpen
                ? 'bg-green-100 text-green-700'
                : 'bg-gray-100 text-gray-700'
            }`}>
              <CheckCircle className="h-3 w-3" />
              {isCurrentlyOpen ? 'Open Now' : 'Closed'}
            </span>
          </div>
          <div className="space-y-2 text-gray-600">
            <p className="flex items-center gap-2">
              <span className="font-medium">{businessHours.weekdays}</span>
            </p>
            <p className="flex items-center gap-2">
              <span className="font-medium">{businessHours.sunday}</span>
            </p>
            <p className="text-sm text-gray-500 italic mt-3">
              {businessHours.note}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
